import Route from '../components/routes/route.js';
import SpeedRoute from '../components/routes/speed-route.js';
import ColorRoute from '../components/routes/color-route.js';
import TrailerRoute from '../components/routes/trailer-route.js';
import AlarmRoute from '../components/routes/alarm-route.js';
import PlaybackControl from '../components/playback.control';
import SensorRoute from '../components/routes/sensor-route';
import StopsMarker from '../components/markers/stops-marker.js';
import FuelingsMarker from '../components/markers/fuelings-marker.js';
import SensorMarker from '../components/markers/sensor';
import RouteClusterPopup from '../components/popup/route-cluster-popup';
import ObjectTailRoute from '../components/routes/object-tail-route';
import TripsRoute from '../components/routes/trips-route.js';

export default class RoutesService {
    constructor(map) {
        this.routesDictionary = [];
        this.fuelingsDictionary = {};
        this.stopsDictionary = {};
        this.fuelingsStopsSensClousterLayerDictionary = {};
        this.selectedRouteId = null;
        this.routesColors = ['green', 'lightgreen', 'yellow', 'red', 'blue', 'gray', 'black', 'purple', 'coral', 'plum'];
        this.playbackРЎontrol = null;
        this.map = map;
        this.currentRouteColorIndex = 0;
        this.stopsLayer;
        this.objectTailTrack = null;

        document.addEventListener('needCenterMap', event => {
            let { oid, date } = event.detail;
            let route = this.routesDictionary[oid];
            if (route === undefined) {
                return;
            }
            let pointIndex = route.playBackTimesArray.indexOf(date);
            if (pointIndex < 0) {
                return;
            }
            let coords = route.playBackCoordsArray[pointIndex];
            try {
                let latLng = new L.LatLng(coords[1], coords[0]);

                if (!this.map.getBounds().contains(latLng)) {
                    this.map.setView(latLng, this.map.getZoom());
                }
                else {

                    // КОСТЫЛЬ!!!!!
                    // Происходит смешивание компонента карты и ExtJs-интерфейса.
                    // TODO При переделке карту надо делать чистым компонентом!

                    var bottomPanel = Ext.ComponentQuery.query("#bottompanel")[0];

                    if (bottomPanel) {

                        let needCenterMap = false;

                        let mapPanelHeight = Ext.ComponentQuery.query("#mapContainerPanel")[0].getBox().height;

                        let currentPointCoords = this.map.latLngToContainerPoint(latLng);

                        if (currentPointCoords.y > mapPanelHeight - bottomPanel.getBox().height)
                            needCenterMap = true;

                        if (!needCenterMap) {
                            let topPanel = Ext.ComponentQuery.query("#toppanel")[0];
                            if (currentPointCoords.y < topPanel.getBox().height + 14)  // 14 - расстояние от верха контейнера до верха панели
                                needCenterMap = true;
                        }

                        if (needCenterMap)
                            this.map.setView(latLng, this.map.getZoom());
                    }
                }
            } catch (err) { };
        });

        document.addEventListener('syncTrackDisplayData', event => {
            let oid = event.detail.oid;
            let date = event.detail.date;
            if (this.routesDictionary[oid] !== undefined) {
                let playback = this.routesDictionary[oid].playback;
                if (!playback || playback.isPlaying()) {
                    return;
                }
                this.playbackРЎontrol.setNeedUpdateChart(false);
                let oldDate = playback.getTime();
                let newDate = date / 1000;
                if (oldDate != newDate) {
                    this.playbackРЎontrol.setTimeSlider(newDate);
                }
            }
        });
    }

    setRouteOnMap(routeInfo, options) {
        if (typeof routeInfo == 'undefined' || !routeInfo.track || routeInfo.track.result != 'Ok'
            || (routeInfo.track.coords.length === 0 && routeInfo.stops.stops.length === 0)
        ) {
            return;
        }

        this._fixNegativeLongitude(routeInfo);

        let oid = routeInfo.track.oid;
        this.clearRoute(oid);
        let routeStyle = options.trackStyle;
        let fullArea = new L.featureGroup();
        let route;
        let routeColor;
        switch (true) {
            case routeStyle == 'object':
                route = this.setObjectRouteOnMap(routeInfo, this.map);
                if (route) {
                    routeColor = route.color;
                    const event = new CustomEvent('map:newRoutePainted', {
                        detail: { objectId: routeInfo.track.oid, color: routeColor },
                    });
                    document.dispatchEvent(event);
                }
                break;
            case routeStyle == 'speed':
                route = this.setSpeedRouteOnMap(routeInfo, this.map);
                break;
            case routeStyle == 'alarm':
                route = this.setAlarmRouteOnMap(routeInfo, this.map);
                break;
            case routeStyle == 'trailer':
            case routeStyle == 'width':
                route = this.setTrailerRouteOnMap(routeInfo, this.map);
                break;
            case routeStyle == 'needSens':
            case routeStyle == 'needsens':
                route = this.setSensorRouteOnMap(routeInfo, this.map);
                break;
            case routeStyle == 'trajectory':
                route = this.setTrajectoryRouteOnMap(routeInfo, this.map);
                break;
            case routeStyle == 'colored':
                route = this.setColoredRouteOnMap(routeInfo, this.map);
                break;
            case routeStyle == 'trips':
                route = this.setTripsRouteOnMap(routeInfo, this.map);
                break;
            default:
                route = this.setObjectRouteOnMap(routeInfo, this.map);
                break;
        };

        let bounds = null;

        if (route) {
            bounds = route.routeLayer.getBounds();
            if (!bounds.isValid()) {
                bounds = route.markersLayer.getBounds();
            }
        }

        if (options.showFuelings && routeInfo.fuelings && routeInfo.fuelings.result == 'Ok' && routeInfo.fuelings.fuelings.length > 0) {
            this.setFuelingsOnMap(routeInfo.fuelings.fuelings, oid, routeColor);
            if (routeInfo.track.coords.length === 0)
                bounds = this.fuelingsStopsSensClousterLayerDictionary[oid].getBounds();
        }

        if (options.showStops && routeInfo.stops && routeInfo.stops.result == 'Ok' && routeInfo.stops.stops.length > 0) {
            this.setStopsOnMap(routeInfo.stops.stops, oid, routeColor);
            if (routeInfo.track.coords.length === 0)
                bounds = this.fuelingsStopsSensClousterLayerDictionary[oid].getBounds();
        }

        if (routeStyle == 'needSens' && routeInfo.track.sensors && routeInfo.track.sensors.length > 0) {
            this.setSensorsOnMap(routeInfo.track.sensors, oid, routeColor);
        }

        if (this.fuelingsStopsSensClousterLayerDictionary[oid]) {
            ((oid) => {
                this.fuelingsStopsSensClousterLayerDictionary[oid].on('clusterdblclick', (a) => {
                    !this.map.isClickBlocked() && a.layer.zoomToBounds({ padding: [20, 20] });
                });

                this.fuelingsStopsSensClousterLayerDictionary[oid].on('clusterclick', (a) => {
                    !this.map.isClickBlocked() && this._showClusterPopup(a, oid)
                });
            })(oid);

            this.map.addLayer(this.fuelingsStopsSensClousterLayerDictionary[oid]);
            bounds.extend(this.fuelingsStopsSensClousterLayerDictionary[oid].getBounds());
        }


        if (bounds && bounds.isValid()) {
            this.map.fitBounds(bounds, { padding: [100, 100], maxZoom: 18 });
        }
        else if (routeInfo.track.coords.length === 1) {
            this.map.setView([routeInfo.track.coords[0].lat, routeInfo.track.coords[0].lon], this.map.getZoom());
        }
    }

    _fixNegativeLongitude(routeInfo) {
        // Если на треке есть переход между положительной и отрицательной долготой на Дальнем востоке - надо фиксить, иначе происходит разрыв трека
        // https://jira.fort.tel/browse/FM-973

        if (!this._needFixNegativeLongitude(routeInfo.track))
            return;

        this._fixNegativeLongitudeOnTrack(routeInfo.track);
        this._fixNegativeLongitudeOnStops(routeInfo.stops);
        this._fixNegativeLongitudeOnFuelings(routeInfo.fuelings);
    }

    _needFixNegativeLongitude(track) {
        let havePositiveLongitude = false;
        let haveNegativeLongitude = false;

        if (track != null && track.coords != null) {
            for (let point of track.coords) {

                if (point.lon < -160) {
                    haveNegativeLongitude = true;
                }

                if (point.lon > 160) {
                    havePositiveLongitude = true;
                }

                if (haveNegativeLongitude && havePositiveLongitude)
                    break;
            }
        }

        return haveNegativeLongitude && havePositiveLongitude;
    }

    _fixNegativeLongitudeOnTrack(track) {
        if (track == null)
            return;

        this._fixNegativeLongitudeInListOfElements(track.coords);

        this._fixNegativeLongitudeInListOfElements(track.photos);

        this._fixNegativeLongitudeInListOfElements(track.sensors);
    }

    _fixNegativeLongitudeOnStops(stops) {
        if (stops == null || stops.stops == null)
            return;

        this._fixNegativeLongitudeInListOfElements(stops.stops);

        console.log('stop after fix', stops.stops);
    }

    _fixNegativeLongitudeOnFuelings(fuelings) {
        if (fuelings == null || fuelings.fuelings == null)
            return;

        this._fixNegativeLongitudeInListOfElements(fuelings.fuelings);
    }

    _fixNegativeLongitudeInListOfElements(points) {
        if (!points)
            return;

        for (let point of points) {
            if (point.lon < 0) {
                point.lon += 360;
            }
        }
    }


    _showClusterPopup(cluster, oid) {
        this._hideClusterPopup();

        let childs = cluster.layer.getAllChildMarkers();
        let latLng = cluster.latlng;
        this.clusterPopup = new RouteClusterPopup('', childs, latLng, this.map, oid);
    }

    _hideClusterPopup() {
        if (this.clusterPopup != null)
            this.map.closePopup();
    }

    setObjectRouteOnMap(routeInfo) {
        if (routeInfo.track && routeInfo.track.result == 'Ok' && routeInfo.track.coords.length > 0) {
            let objectRoute = new Route(routeInfo.track, this.map, this.currentRouteColorIndex, undefined, undefined, undefined, routeInfo);
            this.updateCurrentColorIndex();
            this.routesDictionary[routeInfo.track.oid] = objectRoute;
            this.selectedRouteId = routeInfo.track.oid;
            this.setPlaybackControlOnMap(this.selectedRouteId);
            return objectRoute;
        }
    }

    setSensorRouteOnMap(routeInfo) {
        if (routeInfo.track && routeInfo.track.result == 'Ok' && routeInfo.track.coords.length > 0) {
            let objectRoute = new SensorRoute(routeInfo.track, this.map, this.currentRouteColorIndex, undefined, undefined, undefined, routeInfo);
            this.routesDictionary[routeInfo.track.oid] = objectRoute;
            this.selectedRouteId = routeInfo.track.oid;
            this.setPlaybackControlOnMap(this.selectedRouteId);
            return objectRoute;
        }
    }

    setSpeedRouteOnMap(routeInfo) {
        if (routeInfo.track && routeInfo.track.result == 'Ok' && routeInfo.track.coords.length > 0) {
            let objectRoute = new SpeedRoute(routeInfo.track, this.map, undefined, undefined, undefined, undefined, routeInfo);
            this.routesDictionary[routeInfo.track.oid] = objectRoute;
            this.selectedRouteId = routeInfo.track.oid;
            this.setPlaybackControlOnMap(this.selectedRouteId);
            return objectRoute;
        }
    }

    setAlarmRouteOnMap(routeInfo) {
        if (routeInfo.track && routeInfo.track.result == 'Ok' && routeInfo.track.coords.length > 0) {
            let objectRoute = new AlarmRoute(routeInfo.track, this.map, undefined, undefined, undefined, undefined, routeInfo);
            this.routesDictionary[routeInfo.track.oid] = objectRoute;
            this.selectedRouteId = routeInfo.track.oid;
            this.setPlaybackControlOnMap(this.selectedRouteId);
            return objectRoute;
        }
    }

    setTrailerRouteOnMap(routeInfo) {
        if (routeInfo.track && routeInfo.track.result == 'Ok' && routeInfo.track.coords.length > 0) {
            let objectRoute = new TrailerRoute(routeInfo.track, this.map, this.currentRouteColorIndex, undefined, undefined, undefined, routeInfo);
            this.updateCurrentColorIndex();

            this.routesDictionary[routeInfo.track.oid] = objectRoute;
            this.selectedRouteId = routeInfo.track.oid;
            this.setPlaybackControlOnMap(this.selectedRouteId);
            return objectRoute;
        }
    }

    setTrajectoryRouteOnMap(routeInfo) {
        if (routeInfo.track && routeInfo.track.result == 'Ok' && routeInfo.track.coords.length > 0) {
            let objectRoute = new Route(routeInfo.track, this.map, this.currentRouteColorIndex, false, null, true, routeInfo);
            this.updateCurrentColorIndex();
            this.routesDictionary[routeInfo.track.oid] = objectRoute;
            this.selectedRouteId = routeInfo.track.oid;
            this.setPlaybackControlOnMap(this.selectedRouteId);
            return objectRoute;
        }
    }

    setColoredRouteOnMap(routeInfo) {
        if (routeInfo.track && routeInfo.track.result == 'Ok' && routeInfo.track.coords.length > 0) {
            let objectRoute = new ColorRoute(routeInfo.track, this.map, undefined, undefined, undefined, undefined, routeInfo);
            this.routesDictionary[routeInfo.track.oid] = objectRoute;
            this.selectedRouteId = routeInfo.track.oid;
            this.setPlaybackControlOnMap(this.selectedRouteId);
            return objectRoute;
        }
    }

    setTripsRouteOnMap(routeInfo) {
        if (routeInfo.track && routeInfo.track.result == 'Ok' && routeInfo.track.coords.length > 0) {
            let objectRoute = new TripsRoute(routeInfo, this.map);
            this.routesDictionary[routeInfo.track.oid] = objectRoute;
            this.selectedRouteId = routeInfo.track.oid;
            this.setPlaybackControlOnMap(this.selectedRouteId);
            return objectRoute;
        }
    }

    setFuelingsOnMap(fuelings, oid, routeColor) {
        let fuelingsStopsSensClousterLayer = this.fuelingsStopsSensClousterLayerDictionary[oid];
        if (!fuelingsStopsSensClousterLayer) {
            fuelingsStopsSensClousterLayer = this._createFuelingsStopsSensClousterLayer(oid, routeColor);
        }
        for (let i = 0; i < fuelings.length; i++) {
            let marker = new FuelingsMarker({ ...fuelings[i], routeColor }, i, oid, this.map);
            fuelingsStopsSensClousterLayer.addLayer(marker);
        }
    }

    setStopsOnMap(stops, oid, routeColor) {
        let fuelingsStopsSensClousterLayer = this.fuelingsStopsSensClousterLayerDictionary[oid];
        if (!fuelingsStopsSensClousterLayer) {
            fuelingsStopsSensClousterLayer = this._createFuelingsStopsSensClousterLayer(oid, routeColor);
        }

        for (let i = 0; i < stops.length; i++) {
            let marker = new StopsMarker({ ...stops[i], routeColor }, i, oid, this.map);
            fuelingsStopsSensClousterLayer.addLayer(marker);
        }
    }

    setSensorsOnMap(sensors, oid, routeColor) {
        let fuelingsStopsSensClousterLayer = this.fuelingsStopsSensClousterLayerDictionary[oid];
        if (!fuelingsStopsSensClousterLayer) {
            fuelingsStopsSensClousterLayer = this._createFuelingsStopsSensClousterLayer(oid, routeColor);
        }
        for (let sensor of sensors) {
            let sensorMarker = new SensorMarker({ ...sensor, routeColor }, oid, this.map);
            fuelingsStopsSensClousterLayer.addLayer(sensorMarker);
        }
    }

    _createFuelingsStopsSensClousterLayer(oid, routeColor) {
        let fuelingsStopsSensClousterLayer = new L.markerClusterGroup({
            disableClusteringAtZoom: 20,
            maxClusterRadius: 40,
            zoomToBoundsOnClick: false,
            animate: false,
            clusterPane: 'routeElementsPane',
            test: 'test',
            iconCreateFunction: (cluster) => {
                return this._getIconForCluster(cluster, routeColor);
            }
        });
        this.fuelingsStopsSensClousterLayerDictionary[oid] = fuelingsStopsSensClousterLayer;
        return fuelingsStopsSensClousterLayer;
    }

    _getIconForCluster(cluster, routeColor) {
        let segments = [...new Set(cluster.getAllChildMarkers().map(item => item.getClusterType()))];
        let data = [];
        let angles = [];
        let angle = 360 / segments.length;
        for (var index = 0; index < segments.length; index++) {
            data.push({
                label: cluster.getAllChildMarkers().filter(item => item.getClusterType() === segments[index]).length,
                type: segments[index],
                iconForCluster: cluster.getAllChildMarkers().filter(item => item.getClusterType() === segments[index])[0]._getStatusIcon()
            });
            angles.push(angle);
        }

        function renderGroup(item) {
            return `
                <div class="tooltip-container" style="margin-left: 3px;">
                <span class="leaflet-label leaflet-label-inner" style="margin-left: 0px;"> ${item.label}</span>    
                    <div style="text-align: center;align-items: center;justify-content: center;display: flex;width: 100%;height: 20px;">
                        ${item.iconForCluster}
                    </div>
                </div>
            `;
        }

        let colorStyle = '';
        if (routeColor) {
            colorStyle = ` tooltip-${routeColor}-border`;
        }
        return new L.DivIcon({
            html: `
                <div class="leaflet-tooltip leaflet-zoom-animated leaflet-clickable leaflet-tooltip-bottom${colorStyle}" style="opacity: 0.9;">
                    ${data.map(item => renderGroup(item)).join('')}
                </div>
            `,
            className: 'route-cluster',
            iconSize: new L.Point(30 + 32 * data.length, 30)
        });
    }

    selectRoute(oid) {
        if (this.selectedRouteId && oid != this.selectedRouteId && this.routesDictionary[oid]) {
            this.setPlaybackControlOnMap(oid);
            this.routesDictionary[oid].makeFitBoundsEvent();
        }
    }

    setPlaybackControlOnMap(oid) {
        if (this.routesDictionary[oid].playback) {
            let isHide = this.playbackРЎontrol ? this.playbackРЎontrol.isHide : true;
            this.removePlayBackControl();


            this.selectedRouteId = oid;
            let playback = this.routesDictionary[oid].playback;

            let isShowPhotos = false;
            let photosWindow = null;
            if (this.routesDictionary[oid].arrayOfPhotos.length !== 0) {
                isShowPhotos = true;
                photosWindow = this.routesDictionary[oid].PhotosWindow;
            }

            this.playbackРЎontrol = new PlaybackControl(playback, oid, isHide, isShowPhotos, photosWindow);
            this.playbackРЎontrol.addTo(this.map);
        }
    }

    updateCurrentColorIndex() {
        this.currentRouteColorIndex++;
        this.currentRouteColorIndex = this.currentRouteColorIndex.toString();
        this.currentRouteColorIndex = this.currentRouteColorIndex.substring(this.currentRouteColorIndex.length - 1);
        this.currentRouteColorIndex = parseInt(this.currentRouteColorIndex);
    }

    clearRoute(oid) {
        if (this.routesDictionary[oid]) {
            this.currentRouteColorIndex = this.routesDictionary[oid].clear(this.currentRouteColorIndex);
            delete this.routesDictionary[oid];
        };

        if (oid == this.selectedRouteId) {
            this.removePlayBackControl();
        }

        if (this.stopsDictionary[oid]) {
            this.stopsDictionary[oid].clear();
            delete this.stopsDictionary[oid];
        };

        if (this.fuelingsDictionary[oid]) {
            this.fuelingsDictionary[oid].clear();
            delete this.fuelingsDictionary[oid];
        };
        if (this.fuelingsStopsSensClousterLayerDictionary[oid]) {
            this.map.removeLayer(this.fuelingsStopsSensClousterLayerDictionary[oid]);
            delete this.fuelingsStopsSensClousterLayerDictionary[oid];
        }

        const event = new CustomEvent('map:routeRemoved', {
            detail: { objectId: oid },
        });
        document.dispatchEvent(event);
    }

    clearAllRoutes = () => {
        for (let i = 0; i < this.routesDictionary.length; ++i) {
            if (this.routesDictionary[i]) {
                this.clearRoute(i);
            }
        }
    }

    removePlayBackControl() {
        if (this.playbackРЎontrol) {
            this.selectedRouteId = null;
            this.playbackРЎontrol.delete();
        }
    }

    setObjectTailTrack(objectId, coordinates) {
        if (this.objectTailTrack != null) {
            this.objectTailTrack.clear();
        }

        this.objectTailTrack = new ObjectTailRoute(
            {
                oid: objectId,
                coords: coordinates,
                photos: [],
            },
            this.map,
        );
    }

    removeObjectTailTrack() {
        if (this.objectTailTrack != null) {
            this.objectTailTrack.clear();
            this.objectTailTrack = null;
        }
    }
}
